const getters = {
  correspondence (state) {
    return state.projects.entity.documents.filter(document => document.tag === 'correspondence')
  },

  finalOffer (state) {
    return state.projects.entity.documents.find(document => document.tag === 'final_offer')
  },

  legals (state) {
    return state.projects.entity.documents.filter(document => document.tag === 'legals')
  },

  offerInPrinciple (state) {
    return state.projects.entity.documents.find(document => document.tag === 'offer_in_principle')
  },

  professionalReports (state) {
    return state.projects.entity.documents.filter(document => document.tag === 'professionalReports')
  },

  projectDueDiligence (state) {
    return state.projects.entity.documents.filter(document => document.tag === 'projectDueDiligence')
  },

  qs (state) {
    return state.projects.entity.documents.find(document => document.tag === 'qs_report')
  },

  supportingDocuments (state) {
    return state.projects.entity.documents.filter(document => document.tag === 'supportingDocument')
  },

  valuationReport (state) {
    return state.projects.entity.documents.find(document => document.tag === 'valuation_report')
  }
}

export default getters
